import { Component } from '@angular/core';
import { AlarmService } from './alarm.service';

@Component({
  selector: 'qm-alarm',
  template: ''
})
export class AlarmComponent {

  constructor(alarmService: AlarmService) { }

}
